import { auth } from "./auth-client";

interface DiscordWebhookPayload {
  eventType: "user_signup";
  email: string;
  timestamp?: string;
}

/** The API base; the backend owns the webhook URL and its secret. */
function apiBase(): string {
  return ((import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "").replace(/\/+$/, "");
}

/**
 * Announce an app event in Discord. Fire-and-forget: nothing in the learner's
 * flow depends on it, and a failure is a log line, never an error.
 *
 * The payload is verified server-side: the backend compares the address with the
 * authenticated caller's own email, which is why this sends the caller's token
 * when there is one.
 */
export const sendDiscordWebhook = async (payload: DiscordWebhookPayload): Promise<void> => {
  try {
    const base = apiBase();
    if (!base) return;

    const {
      data: { session },
    } = await auth.getSession();

    fetch(`${base}/v1/notifications/discord`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {}),
      },
      body: JSON.stringify(payload),
    }).catch((error) => {
      console.warn("Discord webhook failed:", error);
    });
  } catch (error) {
    console.warn("Discord webhook error:", error);
  }
};
